import { Tabs as RACTabs, TabList as RACTabList, Tab as RACTab, TabPanel as RACTabPanel } from "react-aria-components";
import { styled } from "../../../../styled-system/jsx";

export const Tabs = styled(RACTabs, {
  base: {
    width: "100%",
    "& .react-aria-Tab": {
      cursor: "pointer",
      outline: "none",
      "&[data-disabled]": {
        cursor: "not-allowed",
        opacity: 0.5,
      },
      "&[data-focus-visible]": {
        outline: "2px solid",
        outlineOffset: "-2px",
        outlineColor: "trellisPalette.11",
      },
    },

    // Horizontal orientation (default)
    "&[data-orientation=horizontal]": {
      "& .react-aria-TabList": {
        display: "flex",
        gap: 0,
        borderBottom: "tabs",
        width: "fit-content",
        fontSize: "medium",
        flexWrap: "wrap",
      },
      "& .react-aria-Tab": {
        borderBottom: "2px solid transparent",
        minWidth: "150px",
        marginBottom: "-1px",
        padding: "small",
        paddingBottom: "8px",
        color: "#666",
        textAlign: "center",
        transition: "border-color 0.15s ease-in-out, color 0.15s ease-in-out",
        whiteSpace: "nowrap",
        "&[data-selected]": {
          borderBottomColor: "#6e548a",
          color: "#300",
          fontWeight: "600",
        },
        "&[data-hovered]:not([data-selected])": {
          borderBottomColor: "transparent",
          color: "#333",
        },
      },
      "& .react-aria-TabPanel": {
        outline: "none",
        paddingTop: "medium",
      },
    },

    // Vertical orientation
    "&[data-orientation=vertical]": {
      display: "flex",
      flexDirection: { base: "column", md: "row" },
      "& .react-aria-TabList": {
        display: "flex",
        flex: "0 0 auto",
        flexDirection: "column",
        borderRight: { md: "tabs" },
        width: "fit-content",
        padding: "small",
        fontSize: "medium",
      },
      "& .react-aria-Tab": {
        display: "flex",
        gap: "small",
        alignItems: "center",
        borderBottom: "none",
        borderRadius: "light",
        paddingY: "xsmall",
        paddingX: "small",
        color: "text.secondary",
        textAlign: { base: "center", md: "left" },
        transition: "background-color 0.15s ease-in-out, color 0.15s ease-in-out",
        "&[data-selected]": {
          color: "darkgrey",
          fontWeight: "bold",
        },
      },
      "& .react-aria-TabPanel": {
        flex: 1,
        outline: "none",
        paddingY: "small",
        paddingX: "medium",
      },
    },
  },
  variants: {
    variant: {
      "primary-nav": {
        // Vertical orientation (primary use case for primary-nav)
        "&[data-orientation=vertical]": {
          display: "block",
          alignSelf: "stretch",
          borderRight: "1px solid {colors.lightgrey}",
          width: "fit-content",
          "& .react-aria-TabList": {
            display: "flex",
            gap: "2px",
            flexDirection: "column",
            borderRight: "none",
            width: "100%",
            padding: 0,
          },
          "& .react-aria-Tab": {
            borderLeft: "3px solid transparent",
            borderRadius: 0,
            padding: "16px 20px",
            color: "text.secondary",
            fontSize: "xlarge",
            fontWeight: "500",
            textAlign: "left",
            transition: "all 0.2s ease",
            "&[data-focus-visible]": {
              outline: "none",
              backgroundColor: "trellisPalette.3/8",
            },
            "&[data-hovered]": {
              color: "trellisPalette.3",
              backgroundColor: "trellisPalette.3/8",
            },
            "&[data-selected]": {
              borderLeftColor: "trellisPalette.3",
              color: "trellisPalette.3",
              fontWeight: "600",
              backgroundColor: "trellisPalette.3/12",
            },
            "&[data-disabled]": {
              cursor: "not-allowed",
              color: "grey",
              opacity: 1,
              "&[data-hovered]": {
                color: "grey",
                backgroundColor: "transparent",
              },
            },
          },
          "& .react-aria-TabPanel": {
            padding: 0,
          },
        },
        // Horizontal orientation
        "&[data-orientation=horizontal]": {
          borderBottom: "1px solid {colors.lightgrey}",
          width: "100%",
          minHeight: "auto",
          "& .react-aria-TabList": {
            display: "flex",
            gap: "2px",
            flexDirection: "row",
            borderBottom: "none",
          },
          "& .react-aria-Tab": {
            borderBottom: "3px solid transparent",
            minWidth: "auto",
            marginBottom: 0,
            padding: "16px 20px",
            color: "text.secondary",
            fontSize: "xlarge",
            fontWeight: "500",
            textAlign: "center",
            transition: "all 0.2s ease",
            "&[data-focus-visible]": {
              outline: "none",
              backgroundColor: "trellisPalette.3/8",
            },
            "&[data-hovered]": {
              color: "trellisPalette.3",
              backgroundColor: "trellisPalette.3/8",
            },
            "&[data-selected]": {
              borderBottomColor: "trellisPalette.3",
              color: "trellisPalette.3",
              fontWeight: "600",
              backgroundColor: "trellisPalette.3/12",
            },
            "&[data-disabled]": {
              cursor: "not-allowed",
              color: "grey",
              opacity: 1,
              "&[data-hovered]": {
                color: "grey",
                backgroundColor: "transparent",
              },
            },
          },
          "& .react-aria-TabPanel": {
            paddingTop: "medium",
          },
        },
      },
    },
  },
});

export const TabList = RACTabList;
export const Tab = RACTab;
export const TabPanel = RACTabPanel;
